import { RouteInfo } from "./sidebar.metadata";

export const ROUTES: RouteInfo[] = [

  {
    path: "",
    title: "Tableau de bord",
    moduleName: "dashboard",
    iconType: "cog",
    icon: "description",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    code: "1710441066142928796",
    submenu: [
       {
    path: "dashboard/admin",
    title: "Admin",
    moduleName: "dashboard",
    iconType: "cog",
    icon: "description",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    code: "1710441066142928796",
    submenu: []
  },
   {
    path: "dashboard/general",
    title: "Général",
    moduleName: "dashboard",
    iconType: "cog",
    icon: "description",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    code: "1710441066142928796",
    submenu: []
  }
    ]
  },
  {
    path: "",
    title: "Paramètres",
    moduleName: "parametres",
    iconType: "cog",
    icon: "description",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    code: "1710441066142928796",
    submenu: [
      {
        path: "/parametres/systeme",
        title: "Système",
        moduleName: "parametres",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        code: "1710523452202528220",
        submenu: [],
      },
      {
        path: "/parametres/divers",
        title: "Divers",
        moduleName: "parametres",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        code: "1710523452202528220",
        submenu: [],
      },
      {
        path: "/parametres/production",
        title: "Production",
        moduleName: "parametres",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        code: "171052348136930523",
        submenu: [],
      },
      {
        path: "/parametres/medical",
        title: "Médical",
        moduleName: "parametres",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        code: "171052349415453764",
        submenu: [],
      },
      {
        path: "/parametres/sinistre",
        title: "Sinistre",
        moduleName: "parametres",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        code: "171052349415453764",
        submenu: [],
      },
      {
        path: "/parametres/comptabilite",
        title: "Comptabilité",
        moduleName: "parametres",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        code: "171052351743258503",
        submenu: [],
      },

    ],
  },
  {
    path: "",
    title: "Production",
    moduleName: "production",
    iconType: "cog",
    icon: "description",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    code: "1710441066142928796",
    submenu: [
      // {
      //   path: "/production/contrat",
      //   title: "Contrat",
      //   moduleName: "production",
      //   iconType: "",
      //   icon: "",
      //   class: "ml-menu",
      //   groupTitle: false,
      //   badge: "",
      //   badgeClass: "",
      //   code: "171052348136930523",
      //   submenu: [],
      // },
      {
        path: "/production/info-beneficiaire",
        title: "Info bénéficiaire",
        moduleName: "production",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        code: "171052348136930523",
        submenu: [],
      },
      
      {
        path: "/production/mouvement-effectif",
        title: "Mouvement effectif",
        moduleName: "production",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        code: "171052348136930523",
        submenu: [],
      },
      {
        path: "/production/autre-mouvement",
        title: "Autre mouvement",
        moduleName: "production",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        code: "171052348136930523",
        submenu: [],
      },
      // {
      //   path: "/production/autres-avenants",
      //   title: "Autres avenants",
      //   moduleName: "production",
      //   iconType: "",
      //   icon: "",
      //   class: "ml-menu",
      //   groupTitle: false,
      //   badge: "",
      //   badgeClass: "",
      //   code: "171052348136930523",
      //   submenu: [],
      // },
      {
        path: "/production/historique-mouvement",
        title: "Historique mouvement",
        moduleName: "production",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        code: "171052348136930523",
        submenu: [],
      },
      
      {
        path: "/production/quittance",
        title: "Quittance",
        moduleName: "production",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        code: "171052348136930523",
        submenu: [],
      },
      // {
      //   path: "/production/honoraires",
      //   title: "Honoraires",
      //   moduleName: "production",
      //   iconType: "",
      //   icon: "",
      //   class: "ml-menu",
      //   groupTitle: false,
      //   badge: "",
      //   badgeClass: "",
      //   code: "171052348136930523",
      //   submenu: [],
      // },
      {
        path: "/production/facturer-garant",
        title: "Facturer garant",
        moduleName: "production",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        code: "171052348136930523",
        submenu: [],
      },
      {
        path: "/production/facturer-police",
        title: "Facturer police",
        moduleName: "production",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        code: "171052348136930523",
        submenu: [],
      },
      // {
      //   path: "/production/consommations",
      //   title: "Consommations",
      //   moduleName: "production",
      //   iconType: "",
      //   icon: "",
      //   class: "ml-menu",
      //   groupTitle: false,
      //   badge: "",
      //   badgeClass: "",
      //   code: "171052348136930523",
      //   submenu: [],
      // },
      // {
      //   path: "/production/accessoires",
      //   title: "Accéssoires",
      //   moduleName: "production",
      //   iconType: "",
      //   icon: "",
      //   class: "ml-menu",
      //   groupTitle: false,
      //   badge: "",
      //   badgeClass: "",
      //   code: "171052348136930523",
      //   submenu: [],
      // },
      // {
      //   path: "/production/commissions",
      //   title: "Commissions",
      //   moduleName: "production",
      //   iconType: "",
      //   icon: "",
      //   class: "ml-menu",
      //   groupTitle: false,
      //   badge: "",
      //   badgeClass: "",
      //   code: "171052348136930523",
      //   submenu: [],
      // },



    ],
  },

  {
    path: "",
    title: "Prestation",
    moduleName: "prestation",
    iconType: "cog",
    icon: "description",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    code: "1710441066142928796",
    submenu: [
      {
        path: "/prestation/tiers-payant",
        title: "Tiers payant",
        moduleName: "prestation",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        code: "1710523452202528220",
        submenu: [],
      },
      // {
      //   path: "/prestation/tpg",
      //   title: "TPG",
      //   moduleName: "prestation",
      //   iconType: "",
      //   icon: "",
      //   class: "ml-menu",
      //   groupTitle: false,
      //   badge: "",
      //   badgeClass: "",
      //   code: "1710523452202528220",
      //   submenu: [],
      // },
      // {
      //   path: "/prestation/remboursement-direct",
      //   title: "Remboursement direct",
      //   moduleName: "prestation",
      //   iconType: "",
      //   icon: "",
      //   class: "ml-menu",
      //   groupTitle: false,
      //   badge: "",
      //   badgeClass: "",
      //   code: "171052348136930523",
      //   submenu: [],
      // },
      {
        path: "/prestation/saisie-rd",
        title: "Saisie RD",
        moduleName: "prestation",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        code: "171052348136930523",
        submenu: [],
      },
      // {
      //   path: "/prestation/factures-tiers-payant",
      //   title: "Facture tiers payant",
      //   moduleName: "prestation",
      //   iconType: "",
      //   icon: "",
      //   class: "ml-menu",
      //   groupTitle: false,
      //   badge: "",
      //   badgeClass: "",
      //   code: "171052348136930523",
      //   submenu: [],
      // },
      // {
      //   path: "/prestation/factures-rd",
      //   title: "Facture rd",
      //   moduleName: "prestation",
      //   iconType: "",
      //   icon: "",
      //   class: "ml-menu",
      //   groupTitle: false,
      //   badge: "",
      //   badgeClass: "",
      //   code: "171052348136930523",
      //   submenu: [],
      // },

    ],
  },
  {
    path: "",
    title: "Médical",
    moduleName: "medical",
    iconType: "cog",
    icon: "description",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    code: "1710441066142928796",
    submenu: [
      {
        path: "/medical/entente-prealable",
        title: "Entente préalable",
        moduleName: "medical",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        code: "1710523452202528220",
        submenu: [],
      },
           {
        path: "/medical/demande-hospitalisation",
        title: "Demande hospitalisation",
        moduleName: "medical",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        code: "171052348136930523",
        submenu: [],
      },
      {
        path: "/medical/renouvellement-bon-medicament",
        title: "Renouvellement bon",
        moduleName: "medical",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        code: "1710523452202528220",
        submenu: [],
      },
         {
        path: "/medical/visite-hospitalisation",
        title: "Visite hospitalisation",
        moduleName: "medical",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        code: "171052349415453764",
        submenu: [],
      },
      //   {
      //   path: "/medical/demande-prestataire",
      //   title: "Demande prestataire",
      //   moduleName: "medical",
      //   iconType: "",
      //   icon: "",
      //   class: "ml-menu",
      //   groupTitle: false,
      //   badge: "",
      //   badgeClass: "",
      //   code: "171052349415453764",
      //   submenu: [],
      // },
  
  
      {
        path: "/medical/traitement-rd",
        title: "Traitement RD",
        moduleName: "medical",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        code: "171052348136930523",
        submenu: [],
      },
 
   
      // {
      //   path: "/medical/derogation",
      //   title: "Dérogation",
      //   moduleName: "medical",
      //   iconType: "",
      //   icon: "",
      //   class: "ml-menu",
      //   groupTitle: false,
      //   badge: "",
      //   badgeClass: "",
      //   code: "171052348136930523",
      //   submenu: [],
      // },
      //     {
      //   path: "/medical/convention-prestataire",
      //   title: "Convention prestataire",
      //   moduleName: "medical",
      //   iconType: "",
      //   icon: "",
      //   class: "ml-menu",
      //   groupTitle: false,
      //   badge: "",
      //   badgeClass: "",
      //   code: "1710523452202528220",
      //   submenu: [],
      // },

    ],
  },
  {
    path: "",
    title: "Sinistre",
    moduleName: "sinistre",
    iconType: "cog",
    icon: "description",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    code: "1710441066142928796",
    submenu: [
      {
        path: "/sinistre/decompte",
        title: "Décompte",
        moduleName: "sinistre",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        code: "1710523452202528220",
        submenu: [],
      },
      {
        path: "/sinistre/validation-decompte",
        title: "Validation décompte",
        moduleName: "sinistre",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        code: "1710523452202528220",
        submenu: [],
      },

    ],
  },
  {
    path: "",
    title: "Comptabilité",
    moduleName: "comptabilite",
    iconType: "cog",
    icon: "description",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    code: "1710441066142928796",
    submenu: [
      {
        path: "/comptabilite/validation-demande-reglement",
        title: "Demande de règlement",
        moduleName: "comptabilite",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        code: "1710523452202528220",
        submenu: [],
      },
      {
        path: "/comptabilite/reglement-prestataire",
        title: "Règlement prestataire",
        moduleName: "comptabilite",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        code: "1710523452202528220",
        submenu: [],
      },
      {
        path: "/comptabilite/reglement-rd",
        title: "Règlement rd",
        moduleName: "comptabilite",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        code: "1710523452202528220",
        submenu: [],
      },
      // {
      //   path: "/comptabilite/autre-reglement",
      //   title: "Autre règelement",
      //   moduleName: "comptabilite",
      //   iconType: "",
      //   icon: "",
      //   class: "ml-menu",
      //   groupTitle: false,
      //   badge: "",
      //   badgeClass: "",
      //   code: "1710523452202528220",
      //   submenu: [],
      // },
      // {
      //   path: "/comptabilite/reglement-effectue",
      //   title: "Règlement éffectué",
      //   moduleName: "comptabilite",
      //   iconType: "",
      //   icon: "",
      //   class: "ml-menu",
      //   groupTitle: false,
      //   badge: "",
      //   badgeClass: "",
      //   code: "1710523452202528220",
      //   submenu: [],
      // },
      {
        path: "/comptabilite/encaissement-garant",
        title: "Encaisser garant",
        moduleName: "comptabilite",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        code: "1710523452202528220",
        submenu: [],
      },
      
      {
        path: "/comptabilite/encaissement-souscripteur",
        title: "Encaisser souscripteur",
        moduleName: "comptabilite",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        code: "1710523452202528220",
        submenu: [],
      },
      {
        path: "/comptabilite/banlance-agee",
        title: "Balance agée",
        moduleName: "comptabilite",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        code: "1710523452202528220",
        submenu: [],
      },
      
      {
        path: "/comptabilite/etat-compta",
        title: "Etat de la compta",
        moduleName: "comptabilite",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        code: "1710523452202528220",
        submenu: [],
      },
      


    ],
  },
  {
    path: "",
    title: "Administration",
    moduleName: "administration",
    iconType: "lock",
    icon: "description",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    code: "1710441083453297610",
    submenu: [
            {
        path: "/administration/type-utilisateur",
        title: "Type utilisateur",
        moduleName: "administration",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        code: "1710441118245254640",
        submenu: [],
      },
      {
        path: "/administration/utilisateurs",
        title: "Utilisateurs",
        moduleName: "administration",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        code: "1710441118245254640",
        submenu: [],
      },
      {
        path: "/administration/roles",
        title: "Roles",
        moduleName: "administration",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        code: "1710441216245876852",
        submenu: [],
      },
      
      {
        path: "/administration/fonctionnalites",
        title: "Fonctionnalites",
        moduleName: "administration",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        code: "1710441503140781272",
        submenu: [],
      },
      {
        path: "/administration/utilisateurs-prestataires",
        title: "Utilisateurs prestataires",
        moduleName: "administration",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        code: "1710441118245254640",
        submenu: [],
      },
      {
        path: "/administration/utilisateurs-garants",
        title: "Utilisateurs garants",
        moduleName: "administration",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        code: "1710441118245254640",
        submenu: [],
      },
      {
        path: "/administration/utilisateurs-beneficiaire",
        title: "Utilisateurs beneficiaire",
        moduleName: "administration",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        code: "1710441118245254640",
        submenu: [],
      },
      // {
      //   path: "/administration/roles-prestataires",
      //   title: "Roles prestataires",
      //   moduleName: "administration",
      //   iconType: "",
      //   icon: "",
      //   class: "ml-menu",
      //   groupTitle: false,
      //   badge: "",
      //   badgeClass: "",
      //   code: "1710441216245876852",
      //   submenu: [],
      // },
      
      // {
      //   path: "/administration/fonctionnalites-prestataires",
      //   title: "Fonctionnalites prestataires",
      //   moduleName: "administration",
      //   iconType: "",
      //   icon: "",
      //   class: "ml-menu",
      //   groupTitle: false,
      //   badge: "",
      //   badgeClass: "",
      //   code: "1710441503140781272",
      //   submenu: [],
      // },
      // {
      //   path: "/administration/circuit-validation",
      //   title: "Circuit validation",
      //   moduleName: "circuit-validation",
      //   iconType: "",
      //   icon: "",
      //   class: "ml-menu",
      //   groupTitle: false,
      //   badge: "",
      //   badgeClass: "",
      //   code: "1710441247077759141",
      //   submenu: [],
      // },

      {
        path: "/administration/configuration",
        title: "Configuration",
        moduleName: "administration",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        code: "1710671802883828415",
        submenu: [],
      },

    ],
  },
  {
    path: "",
    title: "Audit",
    moduleName: "audit",
    iconType: "lock",
    icon: "description",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    code: "1710441083453297610",
    submenu: [
            {
        path: "/audit/historique-connexion",
        title: "Historique connexion",
        moduleName: "audit",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        code: "1710441118245254640",
        submenu: [],
      },
            {
        path: "/audit/historique-navigation",
        title: "Hitorique navigation",
        moduleName: "audit",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        code: "1710441118245254640",
        submenu: [],
      },
      
    ],
  },
  {
    path: "",
    title: "Edititque",
    moduleName: "editique",
    iconType: "lock",
    icon: "description",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    code: "1710441083453297610",
    submenu: [
          
            {
        path: "/editique/etat-de-base",
        title: "Etat de base",
        moduleName: "editique",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        code: "1710441118245254640",
        submenu: [],
      },
        {
        path: "/editique/etat-consommation",
        title: "Etat consommation",
        moduleName: "editique",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        code: "1710441118245254640",
        submenu: [],
      },
      {
        path: "/editique/fiche-technique",
        title: "Fiche technique",
        moduleName: "editique",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        code: "1710441118245254640",
        submenu: [],
      },
    ],
  },
  // {
  //   path: "",
  //   title: "Ged",
  //   moduleName: "ged",
  //   iconType: "lock",
  //   icon: "description",
  //   class: "menu-toggle",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   code: "1710441083453297610",
  //   submenu: [
  //           {
  //       path: "/ged/prestation",
  //       title: "prestation",
  //       moduleName: "ged",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       code: "1710441118245254640",
  //       submenu: [],
  //     },
  //     {
  //       path: "/ged/autre",
  //       title: "Autre document",
  //       moduleName: "ged",
  //       iconType: "",
  //       icon: "",
  //       class: "ml-menu",
  //       groupTitle: false,
  //       badge: "",
  //       badgeClass: "",
  //       code: "1710441118245254640",
  //       submenu: [],
  //     },
  //   ],
  // },

];
